import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "箭头",
  "use": "箭头-usage",
  "viewBox": "0 0 119.02 7.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 119.02 7.95\" id=\"箭头\"><defs><style>#箭头 .cls-1{fill:#aac2c9;}</style></defs><g id=\"箭头_页面-1\"><g id=\"箭头_威胁防护-计划任务-配置信息弹窗\"><g id=\"箭头_箭头_向右\" data-name=\"箭头 向右\"><polygon id=\"箭头_路径\" class=\"cls-1\" points=\"115.38 3.38 0 3.38 0 4.56 115.38 4.56 112 7.95 119.02 3.97 112.11 0 115.38 3.38\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol